<template>
  <div>
    <slot name="title">
      <vAlertHeader
        title="Enter Coupon Code"
        :color="getThemeColor"
      ></vAlertHeader>
    </slot>

    <v-otp-input v-model="coupon" :disabled="loading" :length="7"></v-otp-input>
    <v-btn x-large class="mt-3" color="#2E7D32" dark @click="submitCoupon()"
      >Submit</v-btn
    >
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
export default {
  components: { vAlertHeader },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  props: {
    selectedPlan: {
      default: null,
    },
    company: {
      default: null,
    },
  },
  data: () => ({
    coupon: null,
    loading: false,
  }),
  methods: {
    submitCoupon() {
      if (!this.coupon) {
        alert("Coupon Code Cannot Be Empty!");
        return false;
      }
      this.$store.commit("setLoader", true);
      axios
        .postData("/check-coupon", { coupon: this.coupon })
        .then((response) => {
          if (response == "success") {
            this.$store.commit("setPaymentDone", true);
            this.$toast.success("Coupon Code Accepted", { duration: 3000 });
            localStorage.setItem("garbage", this.company.emis);
            this.$router.push({ path: "/payment-complete" });
          } else {
            this.$toast.error("Invalid Coupon Code", { duration: 3000 });
          }
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>
